import { NavLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import { ISidenav } from '../../../../../interfaces/sidenav.interface';

const styles = {
  active: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0.25rem 0.5rem',
    borderRadius: '4px',
    padding: '1rem 0.75rem',
    color: '#ffffff',
    textDecoration: 'none',
    backgroundColor: '#ffffff20',
  },

  inactive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0.25rem 0.5rem',
    borderRadius: '4px',
    padding: '1rem 0.75rem',
    color: '#ffffff90',
    textDecoration: 'none',
  },
};

const SidenavItem = ({ label, path, icon }: ISidenav) => {
  return (
    <NavLink
      key={path}
      style={({ isActive }) => (isActive ? styles.active : styles.inactive)}
      to={path}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {icon}

        <Typography sx={{ fontSize: '0.875rem' }}>{label}</Typography>
      </Box>
    </NavLink>
  );
};

export default SidenavItem;
